export default __webpack_public_path__ + "static/media/31.612a33da.png";